import gql from 'graphql-tag';

import { userFragment } from '~/shared/graphql-queries/users/index';

export default gql`
  query findManyUserQuery($limit: Int = 20, $filter: FilterFindManyUserInput) {
    findManyUserQuery(filter: $filter, skip: 0, limit: $limit, sort: _ID_DESC) {
      ...UserFragment
    }
  }
  ${userFragment}
`;
